<template>
  <el-dialog ref="dialog" custom-class="w-900 h-480 ovf-auto" title="请选择实例">
    <div>
      <el-table
      :data="tableData"
      stripe
      style="width: 100%">
        <el-table-column
        prop="name"
        label="功能名称">
        </el-table-column>
        <el-table-column
        prop="create_name"
        label="创建人"
        width="150">
        </el-table-column>
        <el-table-column
        label="类型"
        width="150">
          <template scope="scope">
            <span>{{ scope.row.show_type | operation }}</span>
          </template>
        </el-table-column>
        <el-table-column
        label="操作"
        width="100">
          <template scope="scope">
            <el-button size="small" @click="selectReality(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<style>
.search-btn {
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>
<script>
  import http from '../../../assets/js/http'

  export default {
    name: 'reality',
    data() {
      return {
        tableData: []
      }
    },
    methods: {
      closeDialog() {
        this.$refs.dialog.close()
      },
      open() {
        this.$refs.dialog.open()
      },
      selectReality(item) {
        setTimeout(() => {
          this.$emit('selectReality', item.id, item.name)
        }, 0)
        this.closeDialog()
      },
      async getReality() {
        let arr = []
        let res = await this.apiGet(`cms/contents`)
        return this.promiseHandler(arr, res)
      }
    },
    async created() {
      const result = await this.getReality()
      this.tableData = result.list
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// reality.vue?417e001e